import { NotificationType } from "./notification-type.enum";

export class Notification {
    Type: NotificationType;
    Message: string;
    Opacity: number;
}



// WEBPACK FOOTER //
// D:/OTHERS/FirstmediaShowSchedule/src/app/notification/notification.ts